import { render, staticRenderFns } from "./WaveInterferenceViz.vue?vue&type=template&id=7f8c6442&scoped=true"
import script from "./WaveInterferenceViz.vue?vue&type=script&lang=js"
export * from "./WaveInterferenceViz.vue?vue&type=script&lang=js"
import style0 from "./WaveInterferenceViz.vue?vue&type=style&index=0&id=7f8c6442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c6442",
  null
  
)

export default component.exports